<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.0821 3.73223L20.7976 3.03364L20.7976 3.03364L20.0821 3.73223ZM6.6399 21.0355V22.0355C6.90927 22.0355 7.16724 21.9268 7.35542 21.7341L6.6399 21.0355ZM3.22266 21.0355H2.22266C2.22266 21.5878 2.67037 22.0355 3.22266 22.0355V21.0355ZM3.22266 17.4644L2.50714 16.7658C2.32476 16.9526 2.22266 17.2033 2.22266 17.4644H3.22266ZM17.3457 4.43083C17.9065 3.85639 18.8057 3.85639 19.3666 4.43083L20.7976 3.03364C19.452 1.65545 17.2602 1.65545 15.9146 3.03364L17.3457 4.43083ZM19.3666 4.43083C19.9405 5.01864 19.9405 5.98136 19.3666 6.56917L20.7976 7.96636C22.1301 6.60155 22.1301 4.39845 20.7976 3.03364L19.3666 4.43083ZM19.3666 6.56917L5.92439 20.3369L7.35542 21.7341L20.7976 7.96636L19.3666 6.56917ZM6.6399 20.0355H3.22266V22.0355H6.6399V20.0355ZM15.9146 3.03364L2.50714 16.7658L3.93817 18.163L17.3457 4.43083L15.9146 3.03364ZM2.22266 17.4644V21.0355H4.22266V17.4644H2.22266ZM14.4501 5.93083L17.902 9.46636L19.3331 8.06917L15.8811 4.53364L14.4501 5.93083Z"
    />
  </svg>
</template>
